export default __webpack_public_path__ + "static/media/memorial.9b33d744.svg";